<a href="http://complianceonline.azurewebsites.net/Denuncia/Bullest/Denuncia.html" target="_blank" class="botao-denuncias">
    Canal de Ética
    <span style="margin-left: 5px;"><i class="fas fa-bullhorn"></i></span>
</a>